import React, { useState, useContext } from 'react'
import '../Login/Login.css'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils/UI'
import ResetComponent from './resetComponent'
import Loaders from '@/product/components/molecules/Loaders'

// import SEO from '@/utils/SEO'

const ForgotPassword = (props) => {
    const [isLoading, setIsLoading] = useState(false)

    const validationArray = Yup.object({
        user_token: Yup.string().required('Required'),
        password: Yup.string()
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must contain at least one lowercase letter, uppercase letter, number and special character'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'passwords not match')
            .required('Required'),
    })

    const initialValues = {
        user_token: props.match.params.token,
        password: '',
        confirm_password: '',
    }

    const resetPasswordData = [
        {
            label: 'New password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your new password',
            class: 'col-12',
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re-enter your password',
            class: 'col-12',
        },
    ]

    return (
        <div className="login">
            {isLoading ? (
                <Loaders name="banner" isLoading={isLoading} />
            ) : (
                <div className="loginCnt">
                    <div className="row">
                        <div className="loginLogo">
                            <img src={LOGO} alt={SITE_NAME} />
                        </div>
                        <div className="col-12 loginTitle">
                            <h2>Reset Password</h2>
                        </div>

                        <ResetComponent
                            validationArray={validationArray}
                            initialValues={initialValues}
                            resetPasswordData={resetPasswordData}
                            onSuccess={false}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
export default ForgotPassword
